module.exports = __webpack_public_path__ + "static/media/attributes.fe8d4417.svg";